
document.addEventListener('DOMContentLoaded', function () {
  
  const mobileQuickAddForms = document.querySelectorAll('.mobile-quick-add-form');

  mobileQuickAddForms.forEach(form => {
    const quantityInput = form.querySelector('.mobile-quick-add-quantity');
    const minusBtn = form.querySelector('.mobile-quick-add-minus');
    const plusBtn = form.querySelector('.mobile-quick-add-plus');
    const productForm = form.closest('product-form');

    if (!minusBtn || !plusBtn || !quantityInput) return;

    
    let currentQuantity = 0;

    
    function updateButtonStates() {
      minusBtn.disabled = currentQuantity <= 0;
      quantityInput.value = currentQuantity;
    }

    
    minusBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (currentQuantity > 0) {
        currentQuantity--;
        updateButtonStates();
      }
    });

    
    plusBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      currentQuantity++;
      updateButtonStates();

      
      if (productForm) {
        
        const submitEvent = new Event('submit', {
          bubbles: true,
          cancelable: true
        });
        form.dispatchEvent(submitEvent);
      }
    });

    
    document.addEventListener('cart:updated', function () {
     
      if (plusBtn) {
        plusBtn.style.transform = 'scale(1.2)';
        setTimeout(() => {
          plusBtn.style.transform = '';
        }, 200);
      }
    });
  });
});
